module.exports = __webpack_public_path__ + "static/img/5.44f6d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/03/4/1/5.png
// module id = P6gx
// module chunks = 2